import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";

const Shipyard360Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <section className="contentwrapper clearfix" style={{ marginTop: 90 }}>
        <div className="content clearfix">
          {/* Breadcrumbs */}
          <div className="breadcrumbs">
            <Link to="/" className="home">
              Home
            </Link>{" "}
            &gt; <Link to="/shipyard-layout">Shipyard Layout</Link> &gt;{" "}
            <span>Shipyard 360 Visuals</span>
          </div>

          <h1>Shipyard 360 Visuals</h1>

          <div style={{ width: "100%", marginBottom: 40 }}>
            <iframe
              src="https://blueberry.lk/AV/dockyard.html"
              width="100%"
              height="600px"
              style={{ border: 0, display: "block" }}
              title="Shipyard 360 Visuals"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default Shipyard360Page;
